module.exports = __webpack_public_path__ + "static/media/correct.dc18b884.svg";